export default function FaqData() {
    return [
        {
            title: "Why should I consider Disability Insurance for my income protection needs?",
            text: [
                ["According to the U.S. Social Security Administration, just over one in four of today’s 20-year olds will become disabled before they retire.",
                    "At the beginning of 2019, Social Security paid an average monthly disability benefit of about $1,234 to all disabled workers; barely enough to keep a beneficiary above the 2018 poverty level.",
                    "According to the U.S. Census Bureau, as of June 2020 there is approximately 12.6% or 40.6 million disabled Americans. About 50% of those disabled Americans are in their working years, ages 18-64.",
                    "A study released by the Council for Disability Awareness indicated that 65% of working Americans say they could not cover normal living expenses even for a year if their employment income was lost; 38% could not pay their bills for more than three months.",
                ]
            ]
        },
        {
            title: "What is Disability Insurance?",
            text: [
                "Disability insurance is a type of insurance that provides income in the event a worker is unable to work or earn money because of a disability. "
            ]
        },
        {
            title: "What are the types of Disability Insurance?",
            text: [
                "Basically, there are two types of disability insurance: Short and Long term.",
                "Short term disability offers a worker a percentage of their salary if they are unable to work for a short period of time, typically three to six months.",
                "Long term disability offers a worker a percentage of their salary if they are unable to work for a long period of time, typically a period greater than six months."
            ]
        },
        {
            title: "What is an Elimination Period?",
            text: [
                "Regardless of the type of disability insurance you purchase, there will be a period of time called the elimination period that the worker must be disabled before they can begin receiving disability benefits. If the worker is able to work before the elimination period, they will not receive any benefits."
            ]
        },
        {
            title: "How does Disability Insurance Work?",
            text: [
                "The price of Disability Insurance depends on the length of the elimination period, how long a person receives a disability benefit, and how strict the definition of disability is under the agreement made between the insurance company and the worker. Each insurance company has their own definition of what qualifies as a disability.",
                "Some policies pay a monthly benefit, while others pay a single lump sum benefit."
            ]
        }
    ]
}